import HiredReminderModalComponent from './hired-reminder-modal.component'

const HiredReminderModalModule = angular.module('cdbl.hired-reminder-modal', [

])
  .component('cdblHiredReminderModal', HiredReminderModalComponent)
  .name

export default HiredReminderModalModule
